import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const QUERY_NAME = 'Virtual%20Tour%20Toll%20Road';

const VirtualTourTollRoad = ({ isId }: any) => {
  const [loadingState, setLoadingState] = useState(true);
  const [videoState, setVideoState] = useState<any>(null);

  const getData = async () => {
    try {
      const res: any = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/video?name=${QUERY_NAME}`
      );
      const resJson = await res.json();
      setVideoState(resJson.data.link);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    getData();
  }, [videoState]);

  return (
    <div
      style={{
        maxWidth: 1280,
        margin: '0 auto',
        padding: '0 16px',
        marginBottom: '4rem',
      }}
    >
      <Typography style={{ marginBottom: '4rem' }}>
        {isId ? 'Jalan Tol Kami' : 'Our Toll Road'}
        &nbsp; &gt; &nbsp;{' '}
        <span style={{ color: '#e3232a' }}>
          {isId ? 'Virtual Tour Toll Road' : 'Virtual Tour Toll Road'}
        </span>
      </Typography>
      <Typography color='primary' variant='h4' style={{ marginBottom: '2rem' }}>
        {isId ? 'Virtual Tour Toll Road' : 'Virtual Tour Toll Road'}
      </Typography>
      {loadingState ? (
        <Skeleton
          variant='rect'
          style={{
            width: '100%',
            maxWidth: 500,
            height: 300,
          }}
        />
      ) : (
        <div style={{ width: 800 }}>
          <ReactPlayer
            url={videoState}
            controls
            width={1000}
            height={600}
            // style={{ width: 1000, height: 600 }}
          />
        </div>
      )}
    </div>
  );
};

export default VirtualTourTollRoad;
